module.exports = __webpack_public_path__ + "img/iconDownload.7333d6d6.svg";